import { EventEmitter, Output, Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { default as _rollupMoment } from 'moment';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { FormatDateTimePipe } from '@huge-monorepo/hip/tools';
import { ToolsService } from '@huge-monorepo/hip/services';
import { MY_FORMATS, MY_SCHEDULE_FORMATS } from '../format/format';

const moment = _rollupMoment || _moment;

@Component({
  selector: 'tools-date-time',
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_SCHEDULE_FORMATS },
  ],
})
export class DateTimeComponent implements OnInit {
  @Output() notify: EventEmitter<any> = new EventEmitter<string>();
  @ViewChild('elementToFocus', { static: false }) _input: ElementRef;
  dateControl = new FormControl(new Date());
  timeControl: UntypedFormControl;
  dateSelected = false;
  @Input('label') _label: string;
  @Input() providedDate: string = null;
  @Input() Morning: Boolean = false;
  @Input() showTimePicker: boolean = true;
  set label(l: string) {
    this._label = (l && l.trim()) || '<no name set>';
  }
  get label(): string {
    return this._label;
  }
  constructor(private datePipe: FormatDateTimePipe, private tools: ToolsService) {}

  ngOnInit() {
    if (this.showTimePicker) {
      if (this.Morning) {
        this.timeControl = new UntypedFormControl('00:00 AM');
      } else {
        this.timeControl = new UntypedFormControl('11:59 PM');
      }
      if (this.providedDate != null) {
        this.handleProvidedDateTime();
      }
      let date = this.concatDateTime(this.timeControl.value);
      // console.log(date);
      this.emitRegulator(date);
    } else if (!this.showTimePicker && this.providedDate != null) {
      this.dateControl.setValue(new Date(this.providedDate));
    }
  }

  handleProvidedDateTime() {
    let date = this.datePipe.transform(this.providedDate);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let timeString = (hours > 12 ? hours - 12 : hours) + ':' + minutes + (hours > 12 ? ' PM' : ' AM');
    this.dateControl.setValue(date);
    this.timeControl.setValue(timeString);
  }

  formatStartDate(oldFormat: string): string {
    let theDate: Date = new Date(oldFormat);
    theDate.setHours(2, 0, 0, 0);
    return theDate.toISOString();
  }

  formatEndDate(oldFormat: string): string {
    let theDate: Date = new Date(oldFormat);
    theDate.setDate(theDate.getDate() + 1);
    theDate.setHours(1, 59, 59, 999);
    return theDate.toISOString();
  }

  emitRegulator(value: string) {
    this.notify.emit(value);
  }

  openPicker(picker: MatDatepicker<Date>) {
    picker.open();
    setTimeout(() => this._input.nativeElement.focus());
  }

  closePicker(e) {
    setTimeout(() => this._input.nativeElement.blur());
  }

  concatDateTime(newTime: string): string {
    let tmp = newTime.split(':');
    let hours = parseInt(tmp[0]);
    tmp = tmp[1].split(' ');
    let mins = parseInt(tmp[0]);
    let meridian = tmp[1];
    if (meridian == 'PM') {
      if (hours != 12) {
        hours += 12;
      }
    } else {
      if (hours == 12) {
        hours = 0;
      }
    }
    const date = new Date(this.dateControl.value);
    date.setHours(2, 0, 0, 0);
    // console.log(date, date.getUTCMonth(), date.getUTCDate());
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    let returnString = date.getUTCFullYear() + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + 'T';

    if (hours < 10) {
      returnString += '0';
    }
    returnString += hours + ':';
    if (mins < 10) {
      returnString += '0';
    }
    returnString += mins + ':00Z';
    return returnString;
  }

  timeChanged(newTime: string) {
    let date = this.concatDateTime(newTime);
    this.emitRegulator(date);
  }

  dateChanged() {
    if (this.showTimePicker) {
      let date = this.concatDateTime(this.timeControl.value);
      this.emitRegulator(date);
    } else {
      this.emitRegulator(this.dateControl.value.toLocaleString());
    }
  }

  reset() {
    this.handleProvidedDateTime();
  }
}
